import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                  <i className="ri-movie-2-line text-lg text-secondary-900"></i>
                </div>
                <span className="text-xl font-heading font-bold text-background-50">草民影院</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                {footerData.description}
              </p>
            </div>

            <div>
              <h4 className="text-base font-heading font-semibold text-background-50 mb-4">快速导航</h4>
              <div className="grid grid-cols-2 gap-2">
                {footerData.quickLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link.href);
                    }}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-base font-heading font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-400 italic">虚位以待，诚邀优质平台合作</p>
            </div>
          </div>

          <div className="border-t border-background-700/30 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2020-2026 草民影院 caominyingyuan.com 版权所有
            </p>
            <p className="text-xs text-background-500">
              本站所有资源均来自互联网，仅供交流学习，请勿用于商业用途
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}